import { useTranslation } from 'react-i18next';
import { closeMiniApp } from '@telegram-apps/sdk-react';
import { useShallow } from 'zustand/react/shallow';
import CorporateDialog from '@components/dialogs/CorporateDialog.component.jsx';
import CorporateLayout from '@layouts/Corporate.layout.jsx';
import { useUserStore } from '@stores/user.store.js';

export default function EventAvailabilityGuard({ children }) {
  const { t } = useTranslation();
  const { isEventAvailable, user } = useUserStore(
    useShallow((state) => ({
      isEventAvailable: state.isEventAvailable,
      user: state.user,
    })),
  );

  const isEventUnavailable = user && !user.isAdmin && !isEventAvailable;

  if (isEventUnavailable) {
    return (
      <CorporateLayout>
        <CorporateDialog
          title={t('eventsDisabled.title')}
          description={t('eventsDisabled.description')}
          buttonText={t('common.close')}
          onButtonClick={() => closeMiniApp()}
        />
      </CorporateLayout>
    );
  }

  return children;
}
